import React from 'react';
import { Dialog, DialogContent, DialogActions, Typography, Button, Box } from '@mui/material';

const ConfirmationModal = ({
    open,
    text,
    onYes,
    onNo,
    loading = false,
    yesLabel = 'Yes',
    noLabel = 'No',
}) => {
    return (
        <Dialog
            open={open}
            onClose={onNo}
            maxWidth="xs"
            fullWidth
            aria-labelledby="confirm-edit-title"
        >
            <DialogContent>
                <Box
                    display="flex"
                    flexDirection="column"
                    alignItems="center"
                    justifyContent="center"
                    textAlign="center"
                    py={2}
                >
                    <Typography
                        id="confirm-edit-title"
                        variant="subtitle1"
                        sx={{ color: 'black', textTransform: 'none' }}
                    >
                        {text}
                    </Typography>
                </Box>
            </DialogContent>

            <DialogActions sx={{ justifyContent: 'center', pb: 2 }}>
                <Button onClick={onNo} variant="outlined">
                    {noLabel}
                </Button>
                <Button
                    onClick={onYes}
                    variant="contained"
                    color="primary"
                    autoFocus
                    disabled={loading}
                >
                    {yesLabel}
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default ConfirmationModal;
